import React from 'react';
import PageWrapper from '../components/base/PageWrapper';
import Layout from '../layouts/VisitorPrograms';
import TravelerProgramDashboard from '../components/TravelerProgramDashboard';

export default function Page() {
  return {
    title: 'Visitor Programs',
    component: (
      <Layout visitor>
        <PageWrapper showSideNav={false}>
          <TravelerProgramDashboard />
        </PageWrapper>
      </Layout>
    ),
  };
}
